
import React from "react";

import './Tabs.css';

const Tabs = () =>{
    return(
        <div className="container mt-6">
            <div className="row">
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Tabs</h3>
                        </div>
                        <div className="card-body">
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#home">Tab 1</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#menu1">Tab 2</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#menu2">Tab 3</a>
                                </li>
                            </ul>
                            <div className="tab-content mt-4">
                                <div id="home" className="tab-pane active">
                                    <h5>Tab 1</h5>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                                <div id="menu1" className="tab-pane fade">
                                    <h5>Tab 2</h5>
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                </div>
                                <div id="menu2" className="tab-pane fade">
                                    <h5>Tab 3</h5>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Tabs</h3>
                        </div>
                        <div className="card-body">
                            <ul className="nav nav-pills" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="pill" href="#about">About</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="pill" href="#services">Services</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="pill" href="#features">Features</a>
                                </li>
                            </ul>
                            <div class="tab-content mt-4">
                                <div id="about" class="tab-pane active">
                                    <h5>HOME</h5>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                                <div id="services" class="tab-pane fade">
                                    <h5>Menu 1</h5>
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                </div>
                                <div id="features" class="tab-pane fade">
                                    <h5>Menu 2</h5>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Tabs;